// extracted by mini-css-extract-plugin
module.exports = {"main":"Gallery_main__3eLOY","image":"Gallery_image__3zTAH"};